/** Timing values ported from the legacy `ticker/js/script.js` implementation. */
export const TICKER_TIMING = {
    /** Wait before starting the horizontal content scroll animation. */
    scrollDelayMs: 2000,
    /** Total elapsed time before advancing to the next slide when content scrolls. */
    pauseAfterScrollMs: 6000,
    /** Delay before auto-advancing when the active slide does not need scrolling. */
    autoSlideMs: 4000,
    /** Delay before resetting scroll position on a single-slide ticker. */
    singleSlideResetMs: 6000,
    /** Duration of the slide-to-slide transition. */
    slideTransitionMs: 500,
} as const;
